<template>
  <div class="container o-form-page">
    <o-working-overlay :working="working"></o-working-overlay>

    <o-section :title="title" @click="enableDebug($event)" :level="0">
      <item-form
        :form-state="formState"
        :item="item"
        :server-errors="serverErrors"
      ></item-form>
    </o-section>

    <o-action-buttons
      :item="item"
      :form-state="formState"
      :create="create"
      @save="doSave"
      @saveAndClose="doSaveAndClose"
      @saveAndNew="doSaveAndNew"
      @delete="doDeleteItem"
      :show-create-and-new="true"
    ></o-action-buttons>
  </div>
</template>

<script>
import {
  CreateFormPageMixin,
  CreateGroupPermissionMixin,
  UnsavedMixin,
} from "@/vue-ocom/mixins";
import FetchCodeMixin from "@/vue-ocom/mixins/FetchCodeMixin.js";
import ItemForm from "../components/ItemForm.vue";
import OActionButtons from "@/vue-ocom/components/forms/OActionButtons.vue";
import OSection from "@/vue-ocom/components/layout/OSection.vue";
import OWorkingOverlay from "@/vue-ocom/components/OWorkingOverlay.vue";

export default {
  mixins: [
    UnsavedMixin,
    CreateFormPageMixin("FormTemplatePermission", "form_template_permission"),
    CreateGroupPermissionMixin("FormTemplatePermission"),
    FetchCodeMixin(["FormTemplateVersion"]),
  ],
  components: {
    OSection,
    OWorkingOverlay,
    OActionButtons,
    ItemForm,
  },
  computed: {
    title() {
      if (this.create) {
        return "Create Form Template Permission";
      }

      return "Edit Form Template Permission";
    },
  },
};
</script>
